import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./AdminPanel.css";
import AdminDashboard from "./tabs/AdminDashboard";
import UserManagement from "./tabs/UserManagement";
import AdminManagement from "./tabs/AdminManagement";
import LicenseManagement from "./tabs/LicenseManagement";
import PendingApprovals from "./tabs/PendingApprovals";
import AuditLog from "./tabs/AuditLog";
import PartnerManagement from "./tabs/PartnerManagement";
import COALedger from "./tabs/COALedger";
import SupplyChainDisputes from "./tabs/SupplyChainDisputes";
const TABS = [
    { key: "dashboard",  label: "Dashboard" },
    { key: "users",      label: "User Management" },
    { key: "admins",     label: "Admin Management" },
    { key: "licenses",   label: "License Management" },
    { key: "pending",    label: "Pending Approvals" },
    { key: "disputes",   label: "Supply Chain Disputes" },
    { key: "audit",      label: "Audit Log" },
    { key: "coa-ledger", label: "Ledger" },
    { key: "partners",   label: "Partner API Keys" },
];

const AdminPanel = ({ userId, userProfile, setHeaderTitle }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "dashboard");

    useEffect(() => {
        setHeaderTitle("Admin Panel");
    }, []);

    const handleTabChange = (key) => {
        setActiveTab(key);
        setSearchParams({ tab: key });
    };

    const renderTab = () => {
        switch (activeTab) {
            case "dashboard":  return <AdminDashboard />;
            case "users":      return <UserManagement userProfile={userProfile} />;
            case "admins":     return <AdminManagement userProfile={userProfile} />;
            case "licenses":   return <LicenseManagement userProfile={userProfile} />;
            case "pending":    return <PendingApprovals />;
            case "disputes":   return <SupplyChainDisputes />;
            // Prospective Operators was replaced by CRM supply-chain leads (2026-09-23).
            case "prospects":  return <SupplyChainDisputes />;
            case "audit":      return <AuditLog />;
            case "coa-ledger": return <COALedger />;
            case "partners":   return <PartnerManagement userProfile={userProfile} />;
            default:           return <AdminDashboard />;
        }
    };

    return (
        <div className="admin-panel">
            {/* Header */}
            <div className="admin-panel-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z" />
                </svg>
                <h1>Admin Panel</h1>
                <span className={`admin-role-badge ${userProfile === "superadmin" ? "superadmin" : ""}`}>
                    {userProfile}
                </span>
            </div>

            {/* Tab navigation */}
            <div className="admin-tab-bar">
                {TABS.map((tab) => (
                    <button
                        key={tab.key}
                        className={`admin-tab-btn ${activeTab === tab.key ? "active" : ""}`}
                        onClick={() => handleTabChange(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab content */}
            <div className="admin-table-wrapper">
                {renderTab()}
            </div>
        </div>
    );
};

export default AdminPanel;
